export const NO_MARK_PERMISSION = 'Войдите, чтобы оценить комментарий';
export const COMMENT_DELETED = 'Комментарий удален';
